// app/javascript/select2_init.js

//= require select2

document.addEventListener("turbo:load", () => {
    jQuery(document).on('select2:ready', () => {
        jQuery('.select2').select2();
    });
});
